import React from 'react'
import { Shell } from '~/components/molecules/Shell'
import * as S from './styled'
import { InformationSection } from '~/components/molecules/InformationSection'
import { BsBoxArrowUpRight } from 'react-icons/bs'
import Link from 'next/link'
import { PressRelease } from '~/services/types/PressRelease'
import { Mdx } from '~/components/molecules/Mdx'
import { MDXRemoteSerializeResult } from 'next-mdx-remote'
import { parseAndFormatDateForPresRelease } from '~/utils'

export interface Props {
  featurePressRelease: Pick<PressRelease, 'title' | 'slug' | 'date'>
  featurePressReleaseMdx: MDXRemoteSerializeResult
  pressReleases: Pick<PressRelease, 'title' | 'slug'>[]
}

export const Screen = ({
  featurePressRelease,
  featurePressReleaseMdx,
  pressReleases,
}: Props) => (
  <Shell>
    <S.Screen>
      <InformationSection
        imageSrc={'/images/press/barn.webp'}
        priority={true}
        topMargin={false}
      >
        <S.PressReleaseDate>
          {parseAndFormatDateForPresRelease(featurePressRelease.date)}
        </S.PressReleaseDate>
        <S.PressTopHeader>{featurePressRelease.title}</S.PressTopHeader>
        <Mdx mdx={featurePressReleaseMdx} />
        <S.ReadMoreNextLink href={`/press/${featurePressRelease.slug}`}>
          <S.ReadMoreLink>
            <span>Read More</span>
            <BsBoxArrowUpRight />
          </S.ReadMoreLink>
        </S.ReadMoreNextLink>
      </InformationSection>

      <S.PressReleasesSection id={'press-releases'}>
        <S.PressReleasesList>
          <h3>Press Releases</h3>
          <ul>
            {pressReleases.map((pr) => (
              <li key={pr.slug}>
                <Link href={`/press/${pr.slug}`}>
                  <span>{pr.title}</span>
                </Link>
              </li>
            ))}
          </ul>
          <S.PressInquiresNote>
            For press inquiries, please contact{' '}
            <a href={'mailto: press@custodiabank.com'}>
              press@custodiabank.com
            </a>
          </S.PressInquiresNote>
        </S.PressReleasesList>
        <S.PressReleaseSectionImageWrapper>
          <S.PressReleaseSectionImage
            alt={''}
            src={'/images/press/horses.webp'}
            objectFit={'cover'}
            objectPosition={'82% 50%'}
            layout={'fill'}
          />
        </S.PressReleaseSectionImageWrapper>
      </S.PressReleasesSection>
    </S.Screen>
  </Shell>
)
